import { defineComponent, onBeforeMount, ref } from 'vue'
import Breadcrumbs from '@/components/breadcrumbs'
import RightMenu from '@/components/right-menu'
import Logout from '@/components/logout'
import MobileMenu from '@/components/mobile-menu'
import ChangeDataModal from './components/change-data-modal'
import './style.sass'
import { host } from '@/const'
import axios from '@/axios'
// @ts-ignore
import profileIcon from '../assets/profile.svg'
import { mask } from 'maska'
import BetaVersion from "@/components/beta-version";
export default defineComponent({
  setup () {
    const endpoint = ref<string>('/api/v1/client/profile')
    const client = ref<Record<string, Array<string>>>({})
    const isEdit = ref<boolean>(false)
    const typeEditData = ref<string>('')
    const editData = ref<Record<string, Array<string>>>({})

    onBeforeMount(async () => {
      client.value = (await axios.get(`${host}${endpoint.value}`)).data
    })

    async function updateDataClient () {
      client.value = (await axios.get(`${host}${endpoint.value}`)).data
      editData.value = client.value
    }

    function editDataClient (type: any) {
      editData.value = client.value
      typeEditData.value = type
      isEdit.value = true
    }

    function setPhoneMask (phone: string) {
      // @ts-ignore
      return mask(String(phone), '+7 (###) ###-##-##')
    }

    return () => (
      <div class="documents-page">
        <Breadcrumbs items={[{ name: 'Главная', link: '/' }, { name: 'Мой профиль', link: '#' }]}/>
        <BetaVersion />
        <h1 class="page-title">Мой профиль</h1>
        <div class="main-content-two-columns">
          {isEdit.value
            ? (<ChangeDataModal
              updateData={() => updateDataClient()}
              noEdit={(value: any) => { isEdit.value = value }}
              typeData={typeEditData.value}
              data={editData.value}
            />)
            : null
          }
          {client.value !== undefined
            ? (
              <div class="profile-data">
                <div class="personal-data">
                  <div class="profile-icon">
                    <img src={profileIcon}  alt=""/>
                  </div>
                  <div class="info">
                    <p class="last-name">{ client.value.lastName }</p>
                    <p class="first-second-name">{ client.value.firstName } { client.value.secondName }</p>
                    <a class="edit" onClick={ () => editDataClient('personal') }>Изменить</a>
                  </div>
                </div>
                <div class="credentials">
                  <div class="head">
                    <p>Учётные данные</p>
                    <a class="edit" onClick={ () => editDataClient('credentials') }>Изменить</a>
                  </div>
                  <div class="credentials-body">
                    { client.value.clientPhones
                      ? (
                        <div class="credential">
                          <span>Телефон</span>
                          {client.value.clientPhones.length > 0
                            ? (
                              client.value.clientPhones.map((item: any) => (
                                <input value={setPhoneMask(item.phone)} disabled />
                              ))
                            )
                            : (<span>Заполните для альтернативной авторизации</span>)}
                        </div>
                      ) : null
                    }
                    {client.value.clientEmails
                      ? (
                        <div class="credential">
                          <span>Почта</span>
                          { client.value.clientEmails.map((item: any) => (
                            <p>{ item.email }</p>
                          ))}
                        </div>
                      ) : null
                    }
                  </div>
                </div>
                {/* <div class="delivery-and-payments"> */}
                {/*  <div class="delivery-data"> */}
                {/*    <div class="head"> */}
                {/*      <p>Данные доставки</p> */}
                {/*      <a class="edit" onClick={ () => isEdit.value = true }>Изменить</a> */}
                {/*    </div> */}
                {/*    <div class="body"> */}
                {/*      <div class="item"> */}
                {/*        <span>Регион</span> */}
                {/*        <p>Республика Мордовия</p> */}
                {/*      </div> */}
                {/*      <div class="item"> */}
                {/*        <span>Город</span> */}
                {/*        <p>Саранск</p> */}
                {/*      </div> */}
                {/*      <div class="item"> */}
                {/*        <span>Улица</span> */}
                {/*        <p>Полежаева</p> */}
                {/*      </div> */}
                {/*      <div class="item"> */}
                {/*        <span>Дом</span> */}
                {/*        <p>157А</p> */}
                {/*      </div> */}
                {/*    </div> */}
                {/*  </div> */}
                {/*  <div class="payments-data"> */}
                {/*    <div class="head"> */}
                {/*      <p>Способы оплаты</p> */}
                {/*      <a class="edit" onClick={ () => isEdit.value = true }>Изменить</a> */}
                {/*    </div> */}
                {/*    <div class="body"> */}
                {/*      <div class="item"> */}
                {/*        <p class="card">Банковская карта</p> */}
                {/*      </div> */}
                {/*    </div> */}
                {/*  </div> */}
                {/* </div> */}
              </div>
            )
            : null
          }
          <div class="main-content-two-columns-right">
            <div class="main-content-two-columns-right-elem-sticky">
              <RightMenu/>
              <Logout/>
              <MobileMenu/>
            </div>
          </div>
        </div>
      </div>
    )
  }
})